// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NewsList.css */
.news-container {
    padding: 16px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-left: 250px; /* Учитываем ширину Sidebar */
    width: calc(100% - 250px); /* Делаем контейнер адаптивным */
    position: relative;
    z-index: 1;
}

.news-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    position: relative;
    z-index: 2;
}

.news-table th, .news-table td {
    padding: 12px;
    border-bottom: 1px solid #ddd;
    text-align: left;
}

.news-table th {
    background-color: #f9f9f9;
    font-weight: bold;
    font-size: 16px;
}

.news-table tr:hover {
    background-color: #f1f1f1;
}

button {
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: 14px;
    margin: 2px;
    position: relative;
    z-index: 3;
}

button:hover {
    opacity: 0.8;
}

.details-button {
    background-color: #007bff;
    color: white;
}

.edit-button {
    background-color: #ffc107;
    color: black;
}

.delete-button {
    background-color: #dc3545;
    color: white;
}

.add-button {
    background-color: #28a745;
    color: white;
    font-size: 14px;
    padding: 10px 16px;
    margin-top: 16px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 4;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
    text-align: center;
}

.modal input, .modal textarea {
    width: 100%;
    margin-bottom: 12px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.modal button {
    background-color: #007bff;
    color: white;
    font-size: 14px;
    padding: 8px 12px;
    margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/style/NewsList.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB,EAAE,6BAA6B;IACjD,yBAAyB,EAAE,gCAAgC;IAC3D,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["/* NewsList.css */\n.news-container {\n    padding: 16px;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    margin-left: 250px; /* Учитываем ширину Sidebar */\n    width: calc(100% - 250px); /* Делаем контейнер адаптивным */\n    position: relative;\n    z-index: 1;\n}\n\n.news-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n    position: relative;\n    z-index: 2;\n}\n\n.news-table th, .news-table td {\n    padding: 12px;\n    border-bottom: 1px solid #ddd;\n    text-align: left;\n}\n\n.news-table th {\n    background-color: #f9f9f9;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.news-table tr:hover {\n    background-color: #f1f1f1;\n}\n\nbutton {\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-size: 14px;\n    margin: 2px;\n    position: relative;\n    z-index: 3;\n}\n\nbutton:hover {\n    opacity: 0.8;\n}\n\n.details-button {\n    background-color: #007bff;\n    color: white;\n}\n\n.edit-button {\n    background-color: #ffc107;\n    color: black;\n}\n\n.delete-button {\n    background-color: #dc3545;\n    color: white;\n}\n\n.add-button {\n    background-color: #28a745;\n    color: white;\n    font-size: 14px;\n    padding: 10px 16px;\n    margin-top: 16px;\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 4;\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10;\n}\n\n.modal-content {\n    background: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    width: 400px;\n    max-width: 90%;\n    text-align: center;\n}\n\n.modal input, .modal textarea {\n    width: 100%;\n    margin-bottom: 12px;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.modal button {\n    background-color: #007bff;\n    color: white;\n    font-size: 14px;\n    padding: 8px 12px;\n    margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
